var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481.6 30.1c-11.7-11.7-30.7-11.7-42.4 0L187.3 282 82.6 228.1 64 246.7 128 384 265.3 448l18.6-18.6-53.9-104.7L481.6 72.5c11.7-11.7 11.7-30.7 0-42.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwordIcon);
export default __webpack_public_path__ + "static/media/sword-icon.0d396e558630f4bd48c1630c639767c9.svg";
export { ForwardRef as ReactComponent };